module.exports={
    "version": "0.7.0",
    "analyses": {
        "aggregate-intersection": {
            "params": {
                "source": {
                    "type": "node"
                },
                "target": {
                    "type": "node"
                },
                "aggregate_function": {
                    "type": "enum",
                    "values": [
                        "avg",
                        "count",
                        "max",
                        "min",
                        "sum"
                    ]
                },
                "aggregate_column": {
                    "type": "string"
                }
            }
        },
        "buffer": {
            "params": {
                "source": {
                    "type": "node"
                },
                "radius": {
                    "type": "number"
                }
            }
        },
        "filter-category": {
            "params": {
                "source": {
                    "type": "node"
                },
                "column": {
                    "type": "string"
                },
                "accept": {
                    "type": "array",
                    "optional": true
                },
                "reject": {
                    "type": "array",
                    "optional": true
                }
            }
        },
        "filter-range": {
            "params": {
                "source": {
                    "type": "node"
                },
                "column": {
                    "type": "string"
                },
                "min": {
                    "type": "number",
                    "optional": true
                },
                "max": {
                    "type": "number",
                    "optional": true
                }
            }
        },
        "intersection": {
            "params": {
                "source": {
                    "type": "node"
                },
                "target": {
                    "type": "node"
                }
            }
        },
        "moran": {
            "params": {
                "source": {
                    "type": "node"
                },
                "numerator_column": {
                    "type": "string"
                },
                "denominator_column": {
                    "type": "string"
                },
                "significance": {
                    "type": "number"
                },
                "neighbours": {
                    "type": "number"
                },
                "permutations": {
                    "type": "number"
                },
                "w_type": {
                    "type": "enum",
                    "values": [
                        "knn",
                        "queen"
                    ]
                }
            }
        },
        "point-in-polygon": {
            "params": {
                "points_source": {
                    "type": "node"
                },
                "polygons_source": {
                    "type": "node"
                }
            }
        },
        "population-in-area": {
            "params": {
                "source": {
                    "type": "node"
                },
                "final_column": {
                    "type": "string"
                }
            }
        },
        "source": {
            "params": {
                "query": {
                    "type": "string"
                }
            }
        },
        "trade-area": {
            "params": {
                "source": {
                    "type": "node"
                },
                "kind": {
                    "type": "enum",
                    "values": [
                        "walk",
                        "car"
                    ]
                },
                "time": {
                    "type": "number"
                },
                "isolines": {
                    "type": "number"
                },
                "dissolved": {
                    "type": "boolean"
                }
            }
        }
    }
}